export const dataHooks = {
    CHECKBOX: 'list-item-select-checkbox',
    PREFIX: 'list-item-select-prefix',
    SUFFIX: 'list-item-select-suffix',
    TITLE: 'list-item-select-title',
    SUBTITLE: 'list-item-select-subtitle',
};
//# sourceMappingURL=constants.js.map